export enum TimeUnits {
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
}

export enum ChatButtonTypes {
  CALL = 'call',
  WEBSITE = 'website',
  REPLY = 'reply',
}

// Util type to pick enum values
export type PickEnum<T, K extends T> = {
  [P in keyof K]: P extends K ? P : never
}

export interface LoginFormData {
  email: string
  password: string
  isSignup?: boolean
}

export interface SignupFormData {
  email: string
  first_name: string
  last_name: string
  password: string
  region: string
}

// Global API Response type
export interface ApiResponse<TApiData> {
  api_id: string
  data: TApiData
  errors: {
    global_error:
      | string
      | {
          error: string
        }
    error_data: {
      description: string
      comments: string
    }
  }
  message: string
  error?: string

  // Right now only used for CDP
  page_size?: number
  page_number?: number
}

// Type definitions for JSON Schema
export interface JsonSchemaProperty {
  type: string
  title?: string
  description?: string
  enum?: string[]
  enumNames?: string[]
  required?: boolean
  items?: JsonSchemaProperty // For array types
  hidden?: boolean
  defaultValue?: string
  secret?: boolean
  properties?: Record<string, JsonSchemaProperty> // For nested objects
}

export interface JsonSchema {
  type: string
  properties: Record<string, JsonSchemaProperty>
  required?: string[]
  additionalProperties?: boolean
}
